import React from "react";

const LandingSegmentContext = React.createContext({
  form: null,
  onOpenTool: null,
});

export function LandingSegmentProvider({ value, children }) {
  return (
    <LandingSegmentContext.Provider value={value}>
      {children}
    </LandingSegmentContext.Provider>
  );
}

export function useLandingSegmentContext() {
  return React.useContext(LandingSegmentContext);
}
